// extracted by mini-css-extract-plugin
export default {"container":"r0SdECMaDpqwECmPWfYZ","recordingLocation":"XpjTaB_HssiXZ503smqy"};